import { jsx as _jsx } from "react/jsx-runtime";
import loadable from '@loadable/component';
import { useStore, } from '@mcn-platform/models';
import ScormWrapper from './ScormWrapper';
import ScormPlaceholder from './ScormPlaceholder';
const ScormPlayerLazy = loadable(() => import('./ScormPlayerLazy'));
const ScormFrame = ({ itemType, item, itemProgress, course, }) => {
    const store = useStore();
    if (typeof window === 'undefined' || !window.document || !window.document.createElement) {
        return (_jsx(ScormPlaceholder, {}));
    }
    if (window.location.host === store.currentPortal.publicDomain
        || window.location.host === store.currentPortal.distributionDomain) {
        console.log('using scorm player');
        return (_jsx(ScormPlayerLazy, { itemType: itemType, item: item, itemProgress: itemProgress, course: course }));
    }
    console.log('using scorm wrapper');
    return (_jsx(ScormWrapper, { itemType: itemType, item: item, itemProgress: itemProgress, course: course }));
};
ScormFrame.defaultProps = {
    course: undefined,
};
export default ScormFrame;
//# sourceMappingURL=ScormPlayer.js.map